var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBulkFolder2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#b7bac2",
    "data-name": "vuesax/bulk/folder-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.72 2H8.28a.709.709 0 00-.7.7.709.709 0 00.7.7h3.26l1.4 1.86c.31.41.35.47.93.47h3.72a4.128 4.128 0 011.11.15 2.505 2.505 0 01.06.55v.35a.7.7 0 101.4 0v-.36A4.451 4.451 0 0015.72 2z",
    opacity: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Vector",
    d: "M20.14 6.54a4.18 4.18 0 00-1.45-.67 4.074 4.074 0 00-1.11-.15h-3.72c-.58 0-.62-.06-.93-.47l-1.4-1.86A2.878 2.878 0 008.74 2H6.42A4.421 4.421 0 002 6.42v11.16A4.421 4.421 0 006.42 22h11.16A4.421 4.421 0 0022 17.58v-7.44a4.391 4.391 0 00-1.86-3.6zM14.33 16H9.67a.7.7 0 110-1.4h4.65a.709.709 0 01.7.7.694.694 0 01-.69.7z"
  }))));
}
export default SvgVuesaxBulkFolder2;